export const enum UserSignIn2IdEnum {
  /**
   * Property call lead modal
   */
  propertyCallLeadModal = 'propertyCallLeadModal',
}
